import { CircularProgress } from '@mui/material'
import { StmtDistributorDetailsResBodyPayloadDistributorDetailsInner } from '@pimy-b2cweb/apiclient-customer-stmt/dist/models/stmt-distributor-details-res-body-payload-distributor-details-inner'
import { useTranslation } from 'react-i18next'
import { formatPrsAccountNo } from '@/utils'

interface ContributionDetailsProps {
  distributorDetails:
    | StmtDistributorDetailsResBodyPayloadDistributorDetailsInner
    | undefined
  status: string
}

const DistributorDetails = ({
  distributorDetails,
  status,
}: ContributionDetailsProps) => {
  const { t } = useTranslation(['statementPage', 'common'])
  return (
    <>
      {status === 'loading' ? (
        <div className='w-full h-[10vh] m-0 flex justify-center items-center'>
          <CircularProgress className='text-pi-principal-blue' />
        </div>
      ) : (
        <div className='mt-4 flex flex-col gap-10 sm:flex-row'>
          <div className='w-full sm:w-[50%]'>
            <div className='flex gap-8 mb-2'>
              <label
                className='text-right block text-sm font-medium text-pi-gray-2 w-[45%]
       mb-1'
              >
                {t('PRS Plus Account No')}
              </label>
              <span
                className={`border-2 border-black w-[70%] h-[10%] bg-pi-gray-4 ${
                  distributorDetails?.accountNo ? 'p-[2px]' : 'p-[14px]'
                }`}
              >
                {formatPrsAccountNo(distributorDetails?.accountNo)}
              </span>
            </div>

            <div className='flex gap-8 mb-2'>
              <label
                className='text-right block text-sm font-medium text-pi-gray-2 w-[45%]
       mb-1'
              >
                {t('Distributor')}
              </label>
              <span
                className={`border-2 border-black w-[70%] h-[10%] bg-pi-gray-4 ${
                  distributorDetails?.distributor ? 'p-[2px]' : 'p-[14px]'
                }`}
              >
                {distributorDetails?.distributor}
              </span>
            </div>

            <div className='flex gap-8 mb-2'>
              <label
                className='text-right block text-sm font-medium text-pi-gray-2 w-[45%]
       mb-1'
              >
                {t('Consultancy Name')}
              </label>
              <span
                className={`border-2 border-black w-[70%] h-[10%] bg-pi-gray-4 ${
                  distributorDetails?.consultantName ? 'p-[2px]' : 'p-[14px]'
                }`}
              >
                {distributorDetails?.consultantName}
              </span>
            </div>

            <div className='flex gap-8 mb-2'>
              <label
                className='text-right block text-sm font-medium text-pi-gray-2 w-[45%]
       mb-1'
              >
                {t('Contact No')}
              </label>
              <span
                className={`border-2 border-black w-[70%] h-[10%] bg-pi-gray-4 ${
                  distributorDetails?.contactNo ? 'p-[2px]' : 'p-[14px]'
                }`}
              >
                {distributorDetails?.contactNo}
              </span>
            </div>
          </div>
          <div className='w-full sm:w-[50%]'>
            <p className='text-[20px] font-semibold text-gray-700 mb-2 ml-5'>
              {t('Quick Links')}
            </p>
            <div className='flex gap-2'>
              <div className='flex flex-col items-center w-[100px]'>
                <a
                  href='https://www.principal.com.my/en/prs'
                  target='_blank'
                  rel='noopener noreferrer'
                  className='flex flex-col items-center'
                >
                  <img
                    src={require('../../assets/fundPrice.JPG')}
                    alt='Fund Price'
                    className='w-[70%] h-[70%] object-contain'
                  />
                  <p className='text-sm mt-1 text-center'>{t('Fund Price')}</p>
                </a>
              </div>

              <div className='flex flex-col items-center w-[100px]'>
                <a
                  href='https://www.principal.com.my/en/prs'
                  target='_blank'
                  rel='noopener noreferrer'
                  className='flex flex-col items-center'
                >
                  <img
                    src={require('../../assets/fundFactSheet.JPG')}
                    alt='Fund Fact Sheet'
                    className='w-[70%] h-[70%] object-contain'
                  />
                  <p className='text-sm mt-1 text-center'>
                    {t('Fund Fact Sheet')}
                  </p>
                </a>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default DistributorDetails
